<template>
  <div :class="`nobox columns formulate-input-element formulate-input-element--${context.type}`"
    
    :data-type="context.type"
  >

    <FormulateInput
        type="hidden"
        :name="context.name"
        v-model="context.model" />

    <FormulateInput
        class="column is-half"
        type="select"
        :name="'year_'+context.name"
        v-model="year_model"
        placeholder="Select Year"
        :options="year.options"
        @change="changed_year($event)" />

    <FormulateInput
        class="column is-half"
        type="select"
        :name="'month_'+context.name"
        placeholder="Select Month"
        v-model="month_model"
        :options="month.options"
        @change="changed_month($event)" />

<!-- <pre>
Year: {{ year_model }}
Month: {{ month_model }}
Formulate Model: {{ context.model }}
</pre> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      year_model: false,
      month_model: false,
      full_date: false,
      numyears: 5
    }
  },
  watch: {
    
  },
  beforeMount() {
    // set starting state for year/month from saved date    
    if (this.context.model) {
      // convert date into js date object
      let date = new Date(this.context.model);

      this.year_model = date.getFullYear();
      this.month_model = date.getMonth();
    }
  },
  computed: {
    ...mapGetters({ answers: 'flattenedAnswers'}),
    month () {
      let currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth();
      let months = [
        'Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'
      ];
      let selected_valid = false;
      
      let output = 
      {
        "options": [
          { "value": false,     "id": "claim_fulldate_month_none",    "label": "" },
        ]
      }

      if (this.year_model == currentYear) {
        // latest year selected, only allow months before and including current month
        for( let i=0; i <= currentMonth; i++ ) {
          output.options.push({ "value": `${i}`, "id": "claim_fulldate_month_" + months[i], "label": `${months[i]}` });
        }
      } else if (this.year_model == (currentYear - this.numyears)) {
        // earliest year selected, only allow months after current month
        for( let i=currentMonth+1; i < months.length; i++ ) {
          output.options.push({ "value": `${i}`, "id": "claim_fulldate_month_" + months[i], "label": `${months[i]}` });
        }
      } else {
        // full list of months
        for( let i=0; i < months.length; i++ ) {
          output.options.push({ "value": `${i}`, "id": "claim_fulldate_month_" + months[i], "label": `${months[i]}` });
        }
      }

      if (!selected_valid) {
        // clear our current month selection, because its not valid
        //this.reset_month();
      }

      return output;
    },
    year () {
      let output = 
      {
        "options": [
          { "value": false,     "id": "claim_fulldate_month_none",    "label": "" },
        ]
      }

      // dynamically create list of last this.numyears {5} years
      // get current year
      let currentYear = new Date().getFullYear();
      for (let i=0; i <= this.numyears; i++){
        let year = currentYear - i;
        // make sure value is definitely a string, causes weird bug if not
        output.options.push({ "value": `${year}`, "id": "claim_fulldate_year_" + year, "label": `${year}` });
      }

      return output;
    }
  },
  methods: {
    setDate() {
      if (this.month_model && this.year_model) {
        // create date from selected month/year
        this.context.model = this.year_model + '/' + ( parseInt(this.month_model) + 1 ).toString().padStart(2, '0') + '/01';
      } else {
        this.clearDate();
      }
    },
    clearDate() {
      this.context.model = false;
    },
    changed_year (event){

      // check month is valid
      let valid = false;

      // loop over options
      for (var option of this.month.options) {
        if ( this.month_model === option.value ) {
          valid = true;
        }
      }

      if (!valid) {
        // reset month if set to an unselectable option
        this.month_model = false;
      }

      // set if both selects are valid, otherwise clear
      this.setDate();
    },
    changed_month (event){
      // set if both selects are valid, otherwise clear
      this.setDate();
    }
  }
}
</script>

<style lang="scss">
  
</style>